import React from 'react';
import { Box, Skeleton } from '@mui/material';

export default function SectionSkeleton({ height = 500 }) {
    return (
        <Box>
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="rectangular" height={height} sx={{ mt: 1, borderRadius: 1 }} />
        </Box>
    );
}
